import { GridColumnType } from "../../../data/gridColumnType";

export const BoardApprovalUpdateConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "registeredCompanyName",
      allowShort: false,
      colType: GridColumnType.LINK,
      colSettings: {
        isOpenNewTab: true,
        url: "$membershipTaskListLink",
      },
    },
    {
      name: "Assigned Date",
      fieldName: "assignDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD MMM YYYY',
      },
    },
    {
      name: "Board Member Approval",
      fieldName: "approvedElectedCount",
      allowShort: false,
      colType: GridColumnType.NUMBER,
    },
    {
      name: "Board Member Rejection",
      fieldName: "rejectedElectedCount",
      allowShort: false,
      colType: GridColumnType.NUMBER,
    },
    {
      name: "Honorary Advisor Approval",
      fieldName: "approvedHonoraryCount",
      allowShort: false,
      colType: GridColumnType.NUMBER,
    },
    {
      name: "Honorary Advisor Rejection",
      fieldName: "rejectedHonoraryCount",
      allowShort: false,
      colType: GridColumnType.NUMBER,
    },
    {
      name: "Comments",
      fieldName: "totalCommentsCount",
      allowShort: false,
      colType: GridColumnType.NUMBER,
    },
    {
      name: "Application",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: false
      },
      customAction: [
        {
            name: "Accept",
        },
        {
            name: "Reject",
        },
    ],
    },
  ],
};
